// extracted by mini-css-extract-plugin
module.exports = {"dropdown-menu":"DropdownMenu_dropdown-menu__3uldx","avatar-container":"DropdownMenu_avatar-container__2tSi8","initial-placeholder":"DropdownMenu_initial-placeholder__31g_6"};